import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.css';
import { Banner, Logo, Card } from 'common/components';
import * as constants from 'common/constants';

const AuthScreen = ({ children, className, header, headersub, banner }) => {
  const classes = classnames('auth-screen', className);

  return (
    <div className={classes}>
      {banner}
      <Banner id={constants.BANNER_IDS.AUTH} theme={['strong', 'info']} />
      <div className={'auth-screen__content is-flex'}>
        <Logo className={'logo--white'} />
        <Card theme={['narrow']} header={header} headersub={headersub}>
          {children}
        </Card>
      </div>
    </div>
  );
};

AuthScreen.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  header: PropTypes.node,
  headersub: PropTypes.string,
  banner: PropTypes.node,
};

export default AuthScreen;



// WEBPACK FOOTER //
// ./src/containers/AuthScreen/index.js